import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { defineMessages } from '@/lib/i18n';

import { formatPhoneNumber, parsePhone } from '@/lib/formatter';
import { phoneNumber, required } from '@/lib/rule';
import sharedMessages from '@/lib/shared-messages';
import { i18n } from '@/plugins/vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyProfileEditForm',
  props: {
    name: null,
    phone: null,
    maximumUpload: null,
    disabled: { type: Boolean },
    isValidForm: { type: Boolean },
    groupNames: null
  },
  emits: ["update:isValidForm", "update:name", "update:phone"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:isValidForm', data: boolean): void;
  (e: 'update:name', data: string): void;
  (e: 'update:phone', data: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  name: string;
  phone: string;
  maximumUpload: number;
  disabled?: boolean;
  isValidForm: boolean;
  groupNames?: string[];
};

const $t = i18n.t.bind(i18n);

const m = defineMessages({
  contactNumber: '連絡先',
  companyProfile: 'テナント情報',
  tenantGroups: 'テナントグループ',
});



const groupNamesDisplay = computed(() => {
  if (!props.groupNames || props.groupNames.length === 0) {
    return $t(sharedMessages.none);
  }
  return props.groupNames.join(', ');
});



const updateIsValidForm = (e: boolean) => {
  emits('update:isValidForm', e);
};

const updateName = (e: string) => {
  emits('update:name', e);
};

const updatePhone = (e: string) => {
  emits('update:phone', e);
};

return { __sfc: true,$t, m, props, groupNamesDisplay, emits, updateIsValidForm, updateName, updatePhone, formatPhoneNumber, parsePhone, phoneNumber, required, sharedMessages }
}

})